export default __webpack_public_path__ + "static/media/libraryStory.91f37045.mp3";